module.exports = __webpack_public_path__ + "kids_toybox_1.jpg";